import {CustomIcon} from "../../../../shared/assets/icons";
import {SectorIcon} from "../SectorIcon";
import {useLangContext} from 'shared/features/Language';

import './AssemblyBaseSelector.scss';

interface IProps {
  activeBase: number;
  setActiveBase: (activeBase: number) => void;
}

export const AssemblyBaseSelector = ({activeBase, setActiveBase}: IProps) => {
  const {textData} = useLangContext();

  return (
    <div className="assembly-base-selector">
      <h5 className="title">
        {textData.assemblyBaseTitle}
      </h5>
      <div className='assembly-header_switch'>
        <CustomIcon
          name='arrowLeftOutline'
          className={`assembly-header_arrow${activeBase === 0?' disabled':''}`}
          onClick={() => {setActiveBase(+activeBase - 1)}}
        />
        <span className='assembly-header_numbers'>{+activeBase + 1}/4</span>
        <SectorIcon sector={activeBase}/>
        <CustomIcon
          name='arrowRightOutline'
          className={`assembly-header_arrow${activeBase === 3?' disabled':''}`}
          onClick={() => {setActiveBase(activeBase + 1)}}
        />
      </div>
    </div>
  )
}
